import { Rating, RatingProps } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import * as React from "react";

export const RatingHighContrast: React.FC<RatingProps> = (props) => {
  return (
    <Rating
      {...props}
      icon={<StarIcon fontSize="inherit" htmlColor="#d77e02" />}
      emptyIcon={<StarBorderIcon fontSize="inherit" htmlColor="#99948F" />}
    />
  );
};
